import { render, staticRenderFns } from "./BaseCustomerForm.vue?vue&type=template&id=93b13a34&scoped=true&"
import script from "./BaseCustomerForm.vue?vue&type=script&lang=js&"
export * from "./BaseCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseCustomerForm.vue?vue&type=style&index=0&id=93b13a34&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b13a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCol,VIcon,VRow,VSwitch,VTextarea})
